module.exports = __webpack_public_path__ + "static/media/image.d50c7257.webp";